module.exports = __webpack_public_path__ + "static/media/today-kz.f2d90276.svg";